export enum FlagType {
  success = 'success',
  warning = 'warning',
  error = 'error',
}

export enum userType {
  etablissement = 'ETABLISSEMENT',
  candidat = 'CANDIDAT',
}

export enum StatusEnum {
  INVALIDATED = 'Unknown',
  PENDING = 'En cours',
  VALIDATED = 'Validée',
}

// export enum CandidatStatusOnMission {
//   ACCEPTED = 'Accepté',
//   REJECTED = 'Rejected',
//   NEUTRAL = 'Neuteral',
//   ARCHIVED = 'Archived',
//   RESERVED = 'Reserved',
//   CANDIDAT_APPLIED_ON_THIS_MISSION = 'En attente',
//   ACCEPTED_AND_SIGNED_BY_BOTH = 'Confirmé',
//   WAITING_FOR_ESTABLISHMENT_VALIDATION = 'Waiting for establishment validation',
//   MISSION_VALIDATED_WAITING_FOR_PAYMENT = 'MISSION validated waiting for payment',
//   VALIDATION_REJECTED_BY_ESTABLISHMENT = 'Validation rejected by establishment',
//   PAYMENT_DONE = 'Payment done',
// }

export enum CandidatStatusOnMission {
  ACCEPTED = 'ACCEPTED', // 1 ///
  REJECTED = 'REJECTED',
  PENDING = 'PENDING',
  NEUTRAL = 'NEUTRAL',
  EXPIRED = 'EXPIRED',
  ARCHIVED = 'ARCHIVED', // no implementation
  RESERVED = 'RESERVED', // NO IMPLEMENTATION
  CANDIDAT_APPLIED_ON_THIS_MISSION = 'CANDIDAT_APPLIED_ON_THIS_MISSION',
  ACCEPTED_AND_SIGNED_BY_BOTH = 'ACCEPTED_AND_SIGNED_BY_BOTH', // 2
  WAITING_FOR_ESTABLISHMENT_VALIDATION = 'WAITING_FOR_ESTABLISHMENT_VALIDATION',
  MISSION_VALIDATED_WAITING_FOR_PAYMENT = 'MISSION_VALIDATED_WAITING_FOR_PAYMENT', // 3
  VALIDATION_REJECTED_BY_ESTABLISHMENT = 'VALIDATION_REJECTED_BY_ESTABLISHMENT',
  CANCELED_BY_ESTABLISHMENT = 'CANCELED_BY_ESTABLISHMENT',
  CANCELLATION_REQUEST_AFTER_SIGN_CONTRACT = 'CANCELLATION_REQUEST_AFTER_SIGN_CONTRACT',
  CANCELLATION_ACCEPTED_AFTER_SIGNING = 'CANCELLATION_ACCEPTED_AFTER_SIGNING',
  REJECTED_BY_ESTABLISHMENT_AFTER_SIGNING = 'REJECTED_BY_ESTABLISHMENT_AFTER_SIGNING',
  CANCELED_BY_CANDIDATE = 'CANCELED_BY_CANDIDATE',
  CANCELED_BY_INTERIM_AGENCY = 'CANCELED_BY_INTERIM_AGENCY',
  CONTRACT_PENDING_VALIDATION = 'CONTRACT_PENDING_VALIDATION',
  VALIDATED = 'VALIDATED',
  INVALIDATED = 'INVALIDATED',
  PAYMENT_DONE = 'PAYMENT_DONE',
  DRAFT = 'DRAFT',
  WAITING_FOR_VALIDATION = 'WAITING_FOR_VALIDATION'
}

export enum MissionStatusEnum {
  PENDING = 'PENDING',
  VALIDATED = 'VALIDATED',
  INVALIDATED = 'INVALIDATED',
  DRAFT = 'DRAFT',
  CANCELED = 'CANCELED',
  FRAGMENT = 'FRAGMENT'
}
